/**
 * Builds a shareable PDP URL by clearing query params and appending UTMs.
 * Qase 736: Share link clears query params and appends UTMs
 */
export function getShareUrl(baseUrl: string): string {
	const url = new URL(baseUrl);
	url.search = "";
	url.searchParams.set("utm_medium", "share");
	url.searchParams.set("utm_campaign", "pdp_share");
	return url.toString();
}
